import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", {
    class: _normalizeClass(["text", [_ctx.activeLang === 'ja-JP' && 'active-lang']]),
    style: _normalizeStyle({ color: _ctx.color, fontSize: _ctx.fontSize, fontWeight: _ctx.fontWeight, lineHeight: _ctx.lineHeight })
  }, _toDisplayString(_ctx.title), 7))
}